import React from 'react'
import injectSheet from 'react-jss'
import styles from './more-button.styles.js'
import DotsIcon from 'react-icons/lib/fa/ellipsis-h'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const MoreButton = ({
  classes,
  forwardedRef,
  onClick,
  disabled,
  className
}) => (
  <button
    onClick={e => !disabled && onClick(e)}
    ref={forwardedRef}
    className={classNames(
      classes.button,
      { [classes.disabled]: disabled },
      className
    )}>
    <DotsIcon className={classes.icon} />
  </button>
)

MoreButton.propTypes = {
  /** Reference for the DOM node of the button, check ref documentation of React */
  forwardedRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  /** Click handler */
  onClick: PropTypes.func
}

export default injectSheet(styles)(MoreButton)
